export default class MapStyle {
  constructor({ id, name, url }) {
    this.id = id;
    this.name = name;
    this.url = url;
    this.isMapboxHosted =
      typeof url === "string" && url.startsWith("mapbox://styles/");
    this.image = this.isMapboxHosted ? this.generateMapboxThumbnailURL(url) : null;
  }

  generateMapboxThumbnailURL(url) {
    if (typeof url !== "string") return null;
    const prefix = "mapbox://styles/";
    if (!url.startsWith(prefix)) return null;

    const styleId = url.slice(prefix.length);
    return `https://api.mapbox.com/styles/v1/${styleId}/static/-122.4241,37.78,14.25,0,0/200x200?access_token=${process.env.VUE_APP_MAPBOX_TOKEN}`;
  }
}
